import React, {
    useEffect,
    useState,
    useMemo
} from 'react';
import { useQuery } from '@tanstack/react-query';
import { useParams, Link } from "react-router";
import "webcomponent-qr-code";

import { getCustomer } from "../router";

import * as OPTIONS from "../option-fields";
import * as UTILS from "../utils";
import * as QUERIES from "../query-functions";

import LoadingIndicator from '../components/loading-indicator';
import AccountNavigation from './account-navigation';
import UpsellBlock from '../components/upsell-block';
import LogoutButton from '../components/logout-button';
import Logo from '../svg/logo';
import VenueLogos from '../svg/venue-logos';

import AppleWalletSvg from '../svg/apple-wallet';
import GoogleWalletSvg from '../svg/google-wallet';

const AccountTickets = () => {

    const { data: customer } = getCustomer();

    const params = useParams();
    const [tickets, setTickets] = useState(null);

    const { 
        isPending: ordersAuthPending,
        data: ordersDataAuth,
    } = useQuery({
        queryKey: ['ordersDataAuth', customer.id],
        enabled: !!customer?.id,
        queryFn: () => QUERIES.getAuthenticatedOrders(customer.id),
        refetchOnWindowFocus: false,
        retry: false,
    });

    useEffect(() => {
        if (!ordersDataAuth) return;

        const upcoming = UTILS.getUpcomingTickets(ordersDataAuth);

        if (params.instanceId) {
            const upcoming_by_instance = UTILS.getTicketsByInstance(upcoming, params.instanceId);
            setTickets(upcoming_by_instance);
        } else {
            setTickets(upcoming);
        }

    }, [ordersDataAuth]);

    if (ordersAuthPending) return <LoadingIndicator type="page" />

    return (
        <>
            <AccountNavigation />

            <div className='booking-pathway__container booking-pathway__account booking-pathway__account--tickets'>

                <div className='booking-pathway__main-content'>
                    <h1 className='booking-pathway__header'>Tickets</h1>
                    <Link to='/account/orders' className='booking-pathway__breadcrumb'>Back to Orders & tickets</Link>

                    <div className='printable-ticket__list grid'>
                        {tickets?.map((ticket) => 
                            <PrintableTicket key={ticket.id} ticket={ticket} />
                        )}
                        
                        
                    </div>
                    {/* <div>
                        <a className='btn'> Download tickets </a>
                    </div> */}
                    <div className='printable-ticket__list grid'>
                         {tickets && tickets.length > 0 &&
                            <SaveToWallet ticket={tickets[0]} />
                        }
                    </div>
                </div>

                <div className='booking-pathway__footer'>
                    <LogoutButton />

                    <UpsellBlock content={OPTIONS.account.orders_upsell} type="orders-upsell" />
                </div>

            </div>
        </>
    );
};

const PrintableTicket = (props) => {
    const formattedDate = useMemo(() => {
        return UTILS.formatDateTime(props.ticket.instance?.start, true, true)
    }, [props.ticket.instance?.start]);
    
    const { 
        isPending,
        isFetching,
        data: imageData,
    } = useQuery({
        queryKey: ['imageData', props.ticket.instance.event.id],
        queryFn: () => QUERIES.getEventImage(props.ticket.instance.event.id),
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 86400000
    });

    // console.log('TICKET HERE', props.ticket.instance.event.attribute_VenueForTicket)
    
    return (
        <div className='ticket-border'>
            <article className='printable-ticket'>
                <header className='printable-ticket__header'>
                    <div className='printable-ticket__image'>
                        {isPending || isFetching ?
                            <LoadingIndicator />
                        : imageData ?
                            <div dangerouslySetInnerHTML={{__html: imageData}}></div>
                        : 
                            <Logo />
                        }
                    </div>
                    <div className='printable-ticket__qr-code'>
                        {!!props.ticket.barcode ?
                            <>
                                <p className='sr-text'>QR Code</p>
                                <qr-code
                                    data={ props.ticket.barcode }
                                    format="svg"
                                    margin="0"
                                    modulesize="0"
                                />
                            </>
                            : <p className='printable-ticket__qr-code-text'>Ticket not available online</p>
                        }                        
                    </div>

                    <h2 className='printable-ticket__title'>{props.ticket.instance.event.name}</h2>
                </header>

                <div className='printable-ticket__content'>
                    {formattedDate ?
                        <time className='printable-ticket__info printable-ticket__info--date' dateTime={props.ticket.instance.start}>
                            <span>{formattedDate.date}</span>
                            <span>{formattedDate.time}</span>
                        </time>
                    :null}
                    <p className='printable-ticket__info printable-ticket__info--price'>
                        <span>{props.ticket.ticketType?.name}</span>
                        <span className='printable-ticket__info--price--total'>£{props.ticket.total?.toFixed(2)}</span>
                    </p>
                    <p className='printable-ticket__info'>
                        <span>Order No.</span>
                        <span>{props.ticket.orderId}</span>
                    </p>
                </div>

                <footer className='printable-ticket__footer'>
                    <p className='printable-ticket__seat-info'>
                        <span className="sr-text">Seat info:</span>
                        {props.ticket.seat?.attribute_Level ?
                            <span>{props.ticket.seat.attribute_Level}</span>
                        :null}
                        <span>{props.ticket.planName}</span>
                        <span>{props.ticket.seat?.name}</span>
                    </p>

                    {props.ticket.instance.event.attribute_VenueForTicket ?
                        <VenueLogos venue={props.ticket.instance.event.attribute_VenueForTicket} />
                    :null}
                </footer>
            </article>
        </div>
    )
}


const SaveToWallet  = (props) => {  
    const { ticket } = props;
    const google_wallet_url = `https://app.tickets-and-passes.com/api/GooglePass?client=capitaltheatres&barcode=${ticket.barcode}`;
    const apple_wallet_url = `https://app.tickets-and-passes.com/api/ApplePass?client=capitaltheatres&barcode=${ticket.barcode}`;

    return (
        <div className='save-to-wallet'>
            
            <a href={google_wallet_url} target="_blank" rel="noopener noreferrer">
                <GoogleWalletSvg />
                <span className="sr-text">Save to Google Wallet</span>
            </a>

            <a href={apple_wallet_url} target="_blank" rel="noopener noreferrer">
                   <AppleWalletSvg />
                <span className="sr-text">Save to Apple Wallet</span>
            </a>



        </div>

    )
}
export default AccountTickets;
